import { render, staticRenderFns } from "./shop-index.vue?vue&type=template&id=1cce0dd6&"
import script from "./shop-index.vue?vue&type=script&lang=js&"
export * from "./shop-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports